import React from 'react';
import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import { translations } from '../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import FlagIcon from '@mui/icons-material/Flag';

export const RemarkButton = (props) => {
  const { openDialog, haveIcon } = props;
  const { t } = useTranslation();

  const handleOnClick = () => {
    openDialog(true);
  };

  return (
    <Wrapper>
      <Button
        className='ack-btn'
        variant='contained'
        onClick={() => handleOnClick()}
        startIcon={haveIcon && <FlagIcon />}
      >
        {t(translations.remark)}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  float: right;

  .ack-btn {
    color: ${p => p.theme.buttonFont};
    background: ${p => p.theme.buttonColor};
    width: 110px;
    font-size: 12px;
    padding: 5px;
    height: 30px;
    line-height: 1;
  }
`;
